import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  EventEmitter,
} from '@angular/core';
import { SuiModalService } from '@richardlt/ng2-semantic-ui';
import { EditAlertNotificationModal } from '../../../modals/edit-alert-notification-modal/edit-alert-notification-modal.component';
import { DeleteAlertNotificationModal } from '../../../modals/delete-alert-notification/delete-alert-notification.component';

@Component({
  selector: 'app-alert-notification-row',
  templateUrl: './alert-notifications-row.component.html',
  styleUrls: ['./alert-notifications-row.component.scss'],
})
export class AlertNotificationRowComponent implements OnChanges {
  resetPageChange = new EventEmitter<void>();

  constructor(private modalService: SuiModalService) {}
  @Input() alertNotification;
  @Input() pageChange: boolean;

  editAlertNotification() {
    this.modalService
      .open(new EditAlertNotificationModal('Edit Notification', {}))
      .onApprove(() => {})
      .onDeny(() => {});
  }

  deleteAlertNotification() {
    this.modalService
      .open(new DeleteAlertNotificationModal('Delete Notification', {}))
      .onApprove(() => {})
      .onDeny(() => {});
  }

  notificationsSeparated = false;
  separateNotifications() {
    if (this.notificationsSeparated) {
      return;
    }
    this.alertNotification = {
      ...this.alertNotification,
      email: this.alertNotification.notificationSettings.filter(
        (item) => item.notificationType === 'email'
      ),
      slack: this.alertNotification.notificationSettings.filter(
        (item) => item.notificationType === 'slack'
      ),
    };
    this.notificationsSeparated = true;
  }

  parseItem(item) {
    return JSON.parse(item);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes?.alertNotification &&
      changes?.alertNotification.currentValue?.notificationSettings
    ) {
      this.separateNotifications();
    }
    if (changes?.pageChange) {
      this.notificationsSeparated = false;
      this.resetPageChange.emit();
    }
  }
}
